import { queryOptions, skipToken } from '@tanstack/react-query';

import { OfficeScheduleSettingsApi } from '@organization/api/OfficeScheduleSettingsApi';

export const officeScheduleSettingsKeys = {
    all: ['officeScheduleSettings'] as const,
    byOffices: (officeIds: string[]) => [...officeScheduleSettingsKeys.all, { officeIds }] as const,
};

export const officeScheduleSettingsQueryOptions = {
    byOffices: (officeIds: string[]) =>
        queryOptions({
            staleTime: Infinity,
            queryKey: officeScheduleSettingsKeys.byOffices(officeIds),
            queryFn: officeIds.length ? () => OfficeScheduleSettingsApi.find(officeIds) : skipToken,
        }),
};
